import { components } from 'react-select';

import { InputProps } from './Input.types';
import { useStyles } from './Input.styles';

export const Input = ({ children, ...rest }: InputProps) => {
  const styles = useStyles();

  return (
    <components.Input css={styles.root} {...rest}>
      {children}
    </components.Input>
  );
};
